// TODO: Remove eslint disable when feature flag will be removed
/* eslint-disable react-hooks/rules-of-hooks */

import { useContext } from 'react'

import { Form as FormProvider } from 'components/Form'
import Loading from 'components/Loading'
import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { useFeatureFlag } from 'features/user/hooks/useFeatureFlag'
import { useSwitchAdUnitProduct } from '../hooks/useSwitchAdUnitProduct'
import { Form } from './Form'
import { Schema, schema, schemaDefault } from './schema'
import { useUpdateAdUnitRefresher } from './useUpdateAdUnitRefresher'

export const FormContainer = (): JSX.Element => {
  const { isFeatureEnabled: withControllingRefreshParamsOnAdUnitLevel } = useFeatureFlag(
    'yp2827ControlingRefreshParamsOnAdUnitLevel',
  )

  if (withControllingRefreshParamsOnAdUnitLevel) {
    const { adUnit, formId, loading, setTouched, setValid } = useContext(AddEditAdUnitContext)
    const { errors: apiErrors, update } = useUpdateAdUnitRefresher()

    if (!adUnit) {
      return <Loading />
    }

    return (
      <FormProvider<Schema>
        externalErrors={apiErrors}
        id={formId}
        loading={loading}
        onSubmit={update}
        onTouched={setTouched}
        onValid={setValid}
        schema={schema}
        schemaDefaults={schemaDefault(adUnit)}
      >
        {() => <Form />}
      </FormProvider>
    )
  } else {
    const { adUnit, formId, loading, setLoading, setTouched, setValid } =
      useContext(AddEditAdUnitContext)
    const { update } = useSwitchAdUnitProduct({ setLoading })

    const handleSubmit = ({ id, refresherEnabled }: Schema): void =>
      void update({ id, product: 'refresher', value: refresherEnabled })

    if (!adUnit) {
      return <Loading />
    }

    return (
      <FormProvider<Schema>
        id={formId}
        loading={loading}
        onSubmit={handleSubmit}
        onTouched={setTouched}
        onValid={setValid}
        schema={schema}
        schemaDefaults={schemaDefault(adUnit)}
      >
        {() => <Form />}
      </FormProvider>
    )
  }
}
